import Vue from 'vue'
import dateFilter from './date.filter'

Vue.filter('date', dateFilter)



// WEBPACK FOOTER //
// ./src/filters/index.js